import Pagination from "@/models/common/Pagination"
import { decrypt, encrypt } from "./EncryptionService";

export const setPage = (page: number) => {
    const currentPagination = getPageAndPageSize();
    if (currentPagination) {
        currentPagination.page = page;
        localStorage.setItem("current_pagination", encrypt(JSON.stringify(currentPagination)));
    }
    else {
        const pagination: Pagination = {
            page: page,
            pageSize: 10,
            totalCount: 0
        };
        localStorage.setItem("current_pagination", encrypt(JSON.stringify(pagination)));
    }
}

export const setPageSize = (pageSize: number) => {
    const currentPagination = getPageAndPageSize();
    if (currentPagination) {
        currentPagination.pageSize = pageSize;
        localStorage.setItem("current_pagination", encrypt(JSON.stringify(currentPagination)));
    }
    else {
        const pagination: Pagination = {
            page: 1,
            pageSize: pageSize,
            totalCount: 0
        };
        localStorage.setItem("current_pagination", encrypt(JSON.stringify(pagination)));
    }
}

export const getPageAndPageSize = () => {
    try {
        const encryptedCurrentPagination = localStorage.getItem("current_pagination")
        if (encryptedCurrentPagination) {
            const currentPagination = JSON.parse(decrypt(encryptedCurrentPagination)) as Pagination
            return currentPagination ?? null
        }
        return null
    }
    catch {
        return null;
    }
}

export default { getPageAndPageSize, setPage, setPageSize }